<template>
  <div>
    <!-- {{ itemsData }} -->

    <!-- {{ fields[7].label === '상태' }} -->
    <b-table-simple
    class="table b-table text-center"
    :per-page="perPage"
    responsive
      show-empty>
      <b-thead class="thead-light">
        <b-tr>
          <b-th v-for="(item, idx) in fields" :key="idx">{{ item.label }}</b-th>
          <b-th v-if="fields[7].label !== '상태'"><b-form-checkbox :checked="true" :unchecked-value="false" v-model="allCheck" /></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(list,listIdx) in itemsData" :key="listIdx">
          <b-td>
            <span @click="onClickRow(list, list.bookingNo , $event.target)">
              <a href="javascript:void(0)" class="cls_click">{{ list.bookingNo }}</a>
            </span>
          </b-td>
          <b-td>
            {{ list.storeName  }}
          </b-td>
          <b-td>
            {{ list.visitorName }}
          </b-td>
          <b-td>
            {{ list.visitorPhone.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`) }}
          </b-td>
          <b-td v-if="fields[7].label !== '상태'">
            {{ Number(list.adultHeadcount) + Number(list.childHeadcount) + Number(list.babyHeadcount) + '명' }}
          </b-td>
          <b-td>
            <span v-if="fields[7].label !== '상태'">
              {{ $moment(list.bookingRequestDate).format('YYYY-MM-DD HH:mm') }}
            </span>
            <span v-else>
              {{ $moment(list.reservationDate).format('YYYY-MM-DD')}}
            </span>
          </b-td>
          <b-td>
            <span v-if="!$route.path.includes('booking-request')">
              <!-- {{$moment(list.reservationDate).format('YYYY-MM-DD')}} -->
              <span v-if="fields[7].label !== '상태'">
                {{ $moment(list.reservationDate).format('YYYY-MM-DD')}}
              </span>
              <span v-else>
                {{$moment(list.reservationDate).format('HH:mm')}}
              </span>
            </span>
            <span v-else>
              {{$moment(list.reservationDate).format('YYYY-MM-DD HH:mm')}}
            </span>
          </b-td>
          <b-td v-if="fields[7].label === '상태'">
            {{ Number(list.adultHeadcount) + Number(list.childHeadcount) + Number(list.babyHeadcount) + '명' }}
          </b-td>
          <b-td v-if="fields[7].label === '상태'">
            <template v-if="list.bookingStatus == 'Visited' ">
              <span @click="onCancelVisit(list , list.bookingNo , $event.target)">
                <a href="javascript:void(0)" class="cls_click">{{ getBookingStatusText(list.bookingStatus) }} {{ list.noShow
                ? '(노쇼)':''}}</a>
              </span>
            </template>
            <template v-else>
              {{ getBookingStatusText(list.bookingStatus) }}{{ list.noShow ? '(노쇼)':''}}
            </template>
          </b-td>

          <b-td  v-if="fields[7].label !== '상태'">
            <b-button v-if="list.visitorRequests != null && list.visitorRequests != ''" @click="showReq(list)"
              variant="primary default" size="sm">
              <i class="simple-icon-notebook" />
            </b-button>
          </b-td>
          <b-td v-if="fields[7].label !== '상태'">
            <b-button @click="confirmProc(list.bookingNo)" variant="primary">승인</b-button>
            <b-button @click="denyProc(list.bookingNo)" variant="outline-primary">불가</b-button>
          </b-td>
          <b-td v-if="fields[7].label !== '상태'">
            <b-form-checkbox :checked="true" :unchecked-value="false" v-model="list.selected"></b-form-checkbox>
          </b-td>
          <b-td  v-if="fields[7].label === '상태'">
            {{ list.bookingType == 'ManualBooking'? '관리자' : list.siteName=='tablenjoy' || !list.siteName ? '테이블엔조이' : '자체판매' }}
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>



    <!-- <b-table
      key="key"
      head-variant="light"
      ref="generalTable"
      class="vuetable"
      :items="itemsData"
      align="center"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      primary-key="bookingNo"
      responsive
      show-empty
    >

      <template v-slot:head(selected)="row">
        <b-form-checkbox :checked="true" :unchecked-value="false" v-model="allCheck"/>
      </template>


      <template v-slot:cell(bookingNo)="row">

              <span @click="onClickRow(row.item , row.item.bookingNo , $event.target)">
                <a href="javascript:void(0)" class="cls_click">{{ row.item.bookingNo }}</a>
              </span>
      </template>

      <template v-slot:cell(visitorPhone)="row">
        {{ row.item.visitorPhone.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`) }}
      </template>
      <template v-slot:cell(headcount)="row">
        {{Number(row.item.adultHeadcount) +Number(row.item.childHeadcount) + Number(row.item.babyHeadcount)+'명' }}
      </template>

      <template v-slot:cell(freeBooking)="row">
        <a>{{row.item.freeBooking ? '관리자':'테이블엔조이'}}</a>
      </template>


      <template v-slot:cell(reservationDate)="row">

        <span v-if="!$route.path.includes('booking-request')">
          {{$moment(row.item.reservationDate).format('YYYY-MM-DD')}}
        </span>
        <span v-else>
           {{$moment(row.item.reservationDate).format('YYYY-MM-DD HH:mm')}}
        </span>
      </template>
      <template v-slot:cell(reservationDateTime)="row">
        {{$moment(row.item.reservationDate).format('HH:mm')}}
      </template>
      <template v-slot:cell(bookingRequestDate)="row">
        {{$moment(row.item.bookingRequestDate).format('YYYY-MM-DD HH:mm')}}
      </template>

      <template v-slot:cell(bookingStatus)="row">
        <template v-if="row.item.bookingStatus == 'Visited' ">
          <span @click="onCancelVisit(row.item , row.item.bookingNo , $event.target)">
              <a href="javascript:void(0)" class="cls_click">{{ getBookingStatusText(row.item.bookingStatus) }} {{ row.item.noShow ? '(노쇼)':''}}</a>
            </span>
        </template>
      <template v-else>
          {{ getBookingStatusText(row.item.bookingStatus) }}{{ row.item.noShow ? '(노쇼)':''}}
        </template>
      </template>

      <template v-slot:cell(visitorRequests)="row">
        <b-button v-if="row.item.visitorRequests != null && row.item.visitorRequests != ''" @click="showReq(row.item)"
                  variant="primary default" size="sm">
          <i class="simple-icon-notebook"/>
        </b-button>
      </template>


      <template v-slot:cell(button)="row">
        <b-button @click="confirmProc(row.item.bookingNo)" variant="primary">승인</b-button>
        <b-button @click="denyProc(row.item.bookingNo)" variant="outline-primary">불가</b-button>
      </template>

      <template v-slot:cell(selected)="row">
        <b-form-checkbox :checked="true" :unchecked-value="false" v-model="row.item.selected"></b-form-checkbox>
      </template>

      <template v-slot:empty>
        <h5 style="text-align: center; font-weight: lighter">조회된 예약 목록이 없습니다.</h5>
      </template>


    </b-table> -->
  </div>
</template>


<script>

  import {
    mapGetters,
  } from "vuex";

  import '../../../assets/css/custom/common.css'
  import {getBookingStatusText} from "../../../utils";

  export default {
    components: {},
    props: ['items', 'fields', 'currentPage', 'perPage'],
    data() {
      return {
        allCheck: false,
        itemsData: [],
        key: 1,
      }
    },
    mounted() {
      console.log(this.items);
      if (this.items.length !== 0){
        this.itemsData = this.items;
        // this.$set(this.itemsData, 0, val[0])
        // this.$refs.generalTable.$forceUpdate()
        // this.$refs.generalTable.refresh();
        // this.key += 1

      }

    },
    computed: {
      ...mapGetters(['siteName']),
    },
    methods: {
      getBookingStatusText,

      onClickRow(item, bookingNo, target) {
        // console.log(item)
        this.$emit('click-row', item, bookingNo)
      },
      onCancelVisit(item, bookingNo, target) {
        this.$emit('visited-cancel', item, bookingNo)
      },
      confirmProc(bookingNo) {
        this.$emit('confirm-proc', bookingNo)
      }
      , denyProc(bookingNo) {
        this.$emit('deny-proc', bookingNo)
      },

      showReq(item) {
        this.$emit('showReq', item)

      },


    },
    watch: {
      value(newValue){
        console.log(newValue)
      },
      items(val){
        this.itemsData = [];
        if(val.length !== 0){
          this.itemsData = val;

          // this.$set(this.itemsData, 0, val[0])
          // this.$refs.generalTable.$forceUpdate()
          // this.$refs.generalTable.refresh();
          // this.key += 1

        }

      },
      allCheck(chk) {
        this.items.forEach(function(value, index) {
          value.selected = chk
        })
      }

    }

  }
</script>
